module.exports = __webpack_public_path__ + "static/media/videocall.d118c7a1.svg";